import api from './ApiMiddleware';

const getClientAMLScreenings = (clientId) => {
  return api.get(`/api/v1/regulatory/client/${clientId}/screening/records`);
};

const startClientAMLScreening = (clientId) => {
  return api.post(`/api/v1/regulatory/client/${clientId}/screen`);
};

const getClientCrimeScreenings = (clientId) => {
  return api.get(`/api/v1/regulatory/client/${clientId}/crimes/records`);
};

const startClientCrimeScreening = (clientId) => {
  return api.post(`/api/v1/regulatory/client/${clientId}/crimes/screen`);
};

const getCrimeDocument = (clientId, resultDocumentId) => {
  return api.get(
    `/api/v1/regulatory/client/${clientId}/crimes/document/${resultDocumentId}`
  );
};

const ScreeningService = {
  getClientAMLScreenings,
  startClientAMLScreening,
  getClientCrimeScreenings,
  startClientCrimeScreening,
  getCrimeDocument,
};

export default ScreeningService;
